const translations = {
    connectionsSectionHeader: 'Available Connections',
    fieldViewDescription:
        'This connection allows you to send application maps directly to the FieldView™ inbox.',
    fieldViewTitle: 'Climate FieldView™',
    manageConnectionsPageTitle: 'Manage Connections'
};

export default translations;
